import React from 'react';
import PropTypes from 'prop-types';

const flattenReduxFormProps = (Component) => {
	const FlattenReduxFormProps = ({
		input,
		meta,
		excludeError,
		errorMessage,
		...rest
	}) => (
		<Component
			{...rest}
			{...input}
			valid={meta.valid}
			error={
				meta.touched && meta.error && !excludeError
					? errorMessage || meta.error
					: null
			}
			success={meta.touched && meta.valid}
		/>
	);
	FlattenReduxFormProps.propTypes = {
		input: PropTypes.object.isRequired,
		meta: PropTypes.shape({
			valid: PropTypes.bool,
			touched: PropTypes.bool,
			error: PropTypes.string,
		}).isRequired,
		excludeError: PropTypes.bool,
		errorMessage: PropTypes.string,
	};
	FlattenReduxFormProps.displayName = `flattenReduxFormProps(${Component.displayName || Component.name || 'Component'})`;
	return FlattenReduxFormProps;
};

export default flattenReduxFormProps;
